import { ref } from "vue";

const title = ref("");
const subtitle = ref("");
const showMore = ref(false);
const showShare = ref(false);
const showDownload = ref(false);
// The project record backing the "..." menu on the project page (Edit/
// Duplicate/Delete/Reject Share) — Project.vue sets this to the same object
// reference it keeps locally, so ProjectCardMenu's in-place mutations on
// rename stay in sync without any extra plumbing. null on routes with no
// such menu (e.g. the document viewer).
const project = ref(null);
// Gate the two download options inside the download popover — set once the
// document's permissions are known (see Document.vue), separately from
// showDownload so the button doesn't flash options the user can't use.
const canDownloadAnnotated = ref(false);
const canDownloadOriginal = ref(false);

export function useTopBar() {
  function set(opts = {}) {
    title.value = opts.title ?? "";
    subtitle.value = opts.subtitle ?? "";
    showMore.value = !!opts.showMore;
    showShare.value = !!opts.showShare;
    showDownload.value = !!opts.showDownload;
    canDownloadAnnotated.value = !!opts.canDownloadAnnotated;
    canDownloadOriginal.value = !!opts.canDownloadOriginal;
    project.value = opts.project ?? null;
  }
  return { title, subtitle, showMore, showShare, showDownload, canDownloadAnnotated, canDownloadOriginal, project, set };
}
